import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EventPreviewService } from 'src/app/services/event-preview.service';

@Component({
  selector: 'app-event-preview-dialog',
  templateUrl: './event-preview-dialog.component.html',
  styleUrls: ['./event-preview-dialog.component.scss']
})
export class EventPreviewDialogComponent implements OnInit {

  public fullEvent: any;
  public localData:any;

  constructor(
    public _sanitizer: DomSanitizer,
    public _eventPreviewService: EventPreviewService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    // this._adapter.setLocale('pt');

    /*
    console.log("---------------------------------------")
    console.log("this.data")  
    console.log(this.data)
    console.log("---------------------------------------")
   
    console.log(">>>  " + new Date(1580958000*1000))
    console.log(">>>  " + new Date(1581044400*1000))
 */

    console.log("this.data: " + JSON.stringify(this.data))

    const dataPrev = this._eventPreviewService.makeHTMLData(this.data)


    this.fullEvent = this._sanitizer.bypassSecurityTrustHtml(dataPrev)
   
    
  }



}
